import { render, staticRenderFns } from "./AddPaperlessDocumentModal.vue?vue&type=template&id=3aac8d1e&scoped=true&"
import script from "./AddPaperlessDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./AddPaperlessDocumentModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddPaperlessDocumentModal.vue?vue&type=style&index=0&id=3aac8d1e&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac8d1e",
  null
  
)

export default component.exports